import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { AnnouncementWithRelationsDto, ResponseDto } from "@mimber/schema"
import { announcementsKeys } from "../announcements.utils"
import type { CancelAnnouncementScheduleParams } from "./useCancelAnnouncementSchedule.types"

export const useCancelAnnouncementSchedule = (
  options?: UseMutationOptions<
    ResponseDto<AnnouncementWithRelationsDto>,
    Error,
    CancelAnnouncementScheduleParams
  >
): UseMutationResult<
  ResponseDto<AnnouncementWithRelationsDto>,
  Error,
  CancelAnnouncementScheduleParams
> => {
  guardAppUsage("mimber-organization", "useCancelAnnouncementSchedule")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async ({ uuid }: CancelAnnouncementScheduleParams) => {
      const response = await server.post<
        ResponseDto<AnnouncementWithRelationsDto>
      >(`announcements/${uuid}/cancel`)
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: announcementsKeys.findOne(variables.uuid),
      })
      queryClient.invalidateQueries({
        queryKey: announcementsKeys.findAll(),
      })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
